export default __webpack_public_path__ + "src/images/packages/unembeza-boutique-lodge/81718b9a703a730d2b288ac29b06dde7-4.png";